import { createRoot } from 'react-dom/client';
import App from './App';
import { autoResizeRem } from './common/autoResetRem';
import './locales/i18n';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(<App />);

autoResizeRem(document, window);
